<template>
  <div v-if="addressData !==null" class="w-full bg-white pb-16 mt-6 tab-content">
    <div
      class="font-medium text-lg px-4 py-8 mb-4 border-b flex item-center justify-between"
    >
      <h2>{{ $t('message.selfService.infoEmployee.addressInfo.address') }}</h2>
    </div>
    <div class="px-4">
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full sm:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="addressData.country"
            outlined
            readonly
            name="country"
            class="w-full"
            color="primary"
            :label="$t('message.selfService.infoEmployee.addressInfo.country')"
            data-vs-input="country"
          />
        </div>
        <div class="w-full sm:w-1/2 mr-4 mt-10 custom-input relative">
          <zt-input
            v-model="addressData.state"
            outlined
            readonly
            name="state"
            class="w-full"
            color="primary"
            :label="$t('message.selfService.infoEmployee.addressInfo.state')"
            data-vs-input="state"
          />
        </div>
      </div>

      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full sm:w-1/2 mt-10 mr-4 custom-input relative">
          <zt-input
            v-model="addressData.city"
            outlined
            readonly
            name="city"
            class="w-full"
            color="primary"
            :label="$t('message.selfService.infoEmployee.addressInfo.city')"
            data-vs-input="city"
          />
        </div>
        <div class="w-full sm:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="addressData.street"
            outlined
            readonly
            name="street"
            class="w-full"
            color="primary"
            :label="$t('message.selfService.infoEmployee.addressInfo.street')"
            data-vs-input="street"
          />
        </div>
      </div>
      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full sm:w-1/2 mr-4 mt-10 custom-input relative">
        <div class="flex">
          <zt-input
            v-model="addressData.number"
            outlined
            readonly
            name="number"
            class="w-full"
            color="primary"
            :label="
              $t('message.selfService.infoEmployee.addressInfo.addressNumber')
            "
            data-vs-input="number"
          />
          <zt-input
            v-model="addressData.flat"
            outlined
            readonly
            name="flat"
            class="w-full pl-2"
            color="primary"
            :label="$t('message.selfService.infoEmployee.addressInfo.floor')"
            data-vs-input="flat"
          />
       
        <zt-input
            v-model="addressData.department"
            outlined
            readonly
            name="department"
            class="w-full pl-2"
            color="primary"
            :label="
              $t('message.selfService.infoEmployee.addressInfo.department')
            "
            data-vs-input="department"
          />
        </div>
        </div>
        <div class="w-full sm:w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            v-model="addressData.neighborhood"
            outlined
            readonly
            name="neighborhood"
            class="w-full"
            color="primary"
            :label="
              $t('message.selfService.infoEmployee.addressInfo.neighborHood')
            "
            data-vs-input="neighborhood"
          />
        </div>
      </div>

      <div class="flex flex-wrap md:flex-no-wrap">
        <div class="w-full sm:w-1/2 mr-4 mt-10 custom-input relative">
          <zt-input
            v-model="addressData.block"
            outlined
            readonly
            name="block"
            class="w-full"
            color="primary"
            :label="
              $t('message.selfService.infoEmployee.addressInfo.blockStreet')
            "
            data-vs-input="block"
          />
        </div>
        <div class="w-full sm:w-1/2 mr-4 mt-10 custom-input relative">
          <zt-input
            v-model="addressData.type_domicile"
            outlined
            readonly
            name="type_domicile"
            class="w-full"
            color="primary"
            :label="
              $t('message.selfService.infoEmployee.addressInfo.addressType')
            "
            data-vs-input="type-address"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full md:w-2/3 m-6 py-6">
      <zt-alert color="info" filled :closeIcon="false">
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="info-circle-solid" class="text-2xl mr-4"></zt-icon>
            <p>{{ $t('message.selfService.infoEmployee.tab.emptyTab') }}</p>
          </div>
        </template>
      </zt-alert>
    </div>
  </div>
</template>

<script>
export default {
 props: {
    addressData: { type: Object }
  },
}
</script>

<style lang="scss" scoped>
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
